import "./GlobalGatherings.module.css";
import Header from "@/reusable_sections/Header";
import UpcomingGatherings from "./sections/UpcomingGatherings";
import BrandInquiries from "./sections/BrandInquiries";
import Footer from "@/reusable_sections/Footer";
export default function GlobalGatheringsPage() {
  return <div>
      <Header />
      <UpcomingGatherings />
      <BrandInquiries />
      <Footer />
    </div>;
}